import styled from 'styled-components';

export const Container = styled.div`
  height: 100%;
  padding: ${(props) => props.theme.spacing.lg};
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.theme.spacing.md};
`;

export const Line = styled.div`
  height: 12px;
  background: ${(props) => props.theme.colors.greyFive};
  border-radius: ${(props) => props.theme.borderRadius.sm};
  width: ${(props) => props.$width || '100%'};
`;
